export enum PaymentState {
	PAID = 'paid',
	UNPAID = 'unpaid',
}
